import script from "./V4HomeLearningPathMain.vue?vue&type=script&setup=true&lang=js"
export * from "./V4HomeLearningPathMain.vue?vue&type=script&setup=true&lang=js"

import "./V4HomeLearningPathMain.vue?vue&type=style&index=0&id=1034c8c0&lang=css&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1034c8c0"]])

export default __exports__